// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__nPfaO","barLabelOutside":"task-list_barLabelOutside__tv2tV"};